const priceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const strikePrecisionFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 20,
});

/** Uniform decimal places align the axis without rounding distinct strikes together. */
export function formatDistributionStrikes(strikes: readonly number[]): string[] {
  const precision = Math.max(
    2,
    ...strikes.map(
      (strike) =>
        strikePrecisionFormatter.formatToParts(strike).find((part) => part.type === 'fraction')
          ?.value.length ?? 0,
    ),
  );
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
  return strikes.map((strike) => formatter.format(strike));
}

export function formatDistributionPrice(value: number | null): string {
  return value == null || !Number.isFinite(value) ? '-' : priceFormatter.format(value);
}
